import React, { useEffect, useState } from "react";
import "./MyAddress.css";
import Header from "../../../Layout/Header/Header";
import Footer from "../../../Layout/Footer/Footer";
import RemoveAddressModal from "../CustomModals/RemoveAddressModal";

import { useLocation, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import {
  addAddressApi,
  deleteAddressApi,
  getAddressLists,
  getUserAddressByIdAPI,
  getUserAddressTypeAPI,
  updateSetAsDefaultAddressAPI,
} from "../../../../../Store/Action/addressAction";
import { toast } from "react-toastify";
import Icons from "../../../../../Config/Images";
import CustomLoader from "../../../CustomComponents/CustomLoader/CustomLoader";

const ADDRESS_TYPES = {
  BILLING: "billing",
  SHIPPING: "shipping",
};

const MyAddress = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [activeAddressType, setActiveAddressType] = useState(
    ADDRESS_TYPES.SHIPPING
  );
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [addresses, setAddresses] = useState({ billing: null, shipping: [] });
  const [addressToDelete, setAddressToDelete] = useState(null);
  const [userAddressTypeData, setUserAddressTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [triggerRefresh, setTriggerRefresh] = useState(0);
  const handleAddressTypeClick = (type) => setActiveAddressType(type);

  useEffect(() => {
    if (location?.state?.fromChangeBillingAddress) {
      setActiveAddressType(ADDRESS_TYPES.BILLING);
    }
  }, []);
  const handleAddress = (type, address) => {
    navigate(`/my-account/${type}-address`, {
      state: { addressType: activeAddressType, addressData: address },
    });
  };

  const handleRemoveAddress = (addressId) => {
    setAddressToDelete(addressId);
    setIsRemoveModalOpen(true);
  };

  const handleDefaultAddress = async (userAddressId) => {
    try {
      // dispatch(
      //   getUserAddressByIdAPI(userAddressId, (result) => {
      //     navigate("/cart", {
      //       state: { selectedShippingData: result }, // Ensure you pass data through `state`
      //     });
      //   })
      // );
      const requestData = {
        user_address_id: userAddressId,
        default_address_flag: true,
      };
      dispatch(
        updateSetAsDefaultAddressAPI(requestData, (result) => {
          if (result?.status) {
            setTriggerRefresh((prev) => prev + 1);
            // navigate("/cart");
          }
        })
      );
    } catch (error) {
      console.log("Error updating address:", error);
    }
  };

  // Corrected: Reference `addresses.billing` instead of just `billing`
  const shouldShowAddAddress =
    activeAddressType === ADDRESS_TYPES.SHIPPING ||
    (activeAddressType === ADDRESS_TYPES.BILLING && addresses.billing === null);

  const confirmRemoveAddress = async () => {
    if (addressToDelete) {
      const reqdata = {
        user_address_id: addressToDelete,
        flag_deleted: true,
      };
      dispatch(
        addAddressApi(reqdata, async (result) => {
          if (result?.status) {
            toast.success("Address deleted successfully!");
            await dispatch(
              getAddressLists({}, (result) => {
                if (result?.status) {
                  setAddresses({
                    billing: result?.data?.billing_address,
                    shipping: result?.data?.shipping_address,
                  });
                }
              })
            );
          } else {
            toast.error("Failed to delete address.");
          }
          setIsRemoveModalOpen(false);
          setAddressToDelete(null);
        })
      );
    } else {
      toast.warn("No Address Selected to delete.");
    }
  };

  const cancelRemoveAddress = () => setIsRemoveModalOpen(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getAddressLists({}, (result) => {
        if (result?.status) {
          setAddresses({
            billing: result?.data?.billing_address,
            shipping: result?.data?.shipping_address,
          });
          setIsLoading(false);
        } else {
          toast.error("Failed to load addresses.");
          setIsLoading(false);
        }
      })
    );
  }, [dispatch, triggerRefresh]);

  useEffect(() => {
    dispatch(
      getUserAddressTypeAPI({}, (result) => {
        setUserAddressTypeData(result);
      })
    );
  }, [dispatch]);

  const renderAddressCards = () => {
    const currentAddresses =
      activeAddressType === ADDRESS_TYPES.BILLING
        ? addresses.billing
        : addresses.shipping;

    // If there's no address data for the selected type, show a message.
    if (
      !currentAddresses ||
      (Array.isArray(currentAddresses) && currentAddresses.length === 0)
    ) {
      return (
        <div className="no-address-message">
          <p>
            No{" "}
            {activeAddressType === ADDRESS_TYPES.BILLING
              ? "Billing"
              : "Shipping"}{" "}
            address available.
          </p>
        </div>
      );
    }

    // For the billing address, make sure it's not null
    const addressesToRender = Array.isArray(currentAddresses)
      ? currentAddresses
      : [currentAddresses];

    return addressesToRender.map((address) => (
      <div
        className="address-card"
        key={address.user_address_id}
        style={{ position: "relative" }}
      >
        {address.defaultaddress == true && (
          <span
            style={{
              position: "absolute",
              right: 14,
              top: 8,
              color: "#565959",
              fontFamily: "Poppins,'sans-serif ",
              fontSize: "14px",
            }}
          >
            Default
          </span>
        )}
        <p style={{ fontWeight: "600", marginBottom: "10px" }}>
          {address.user_first_name || "Name Not Provided"}
        </p>
        <p>{address.user_address_1}</p>
        <p>{address.user_address_2}</p>
        <p>{address.city}</p>
        <p>
          {address.state} {address.zip_code}
        </p>
        <p style={{ marginTop: "15px" }}>
          Mobile No: {address.user_mobile_number}
        </p>
        <div className="edit-remove-div">
          <span
            onClick={() => handleAddress("edit", address)}
            className="edit-text"
          >
            Edit &nbsp; |
          </span>
          &nbsp;
          <span
            onClick={() => handleRemoveAddress(address.user_address_id)}
            className="remove-text"
          >
            Remove
          </span>
          {activeAddressType === ADDRESS_TYPES.SHIPPING &&
            address.defaultaddress == false && (
              <span
                onClick={() => handleDefaultAddress(address.user_address_id)}
                className="default-text"
              >
                &nbsp; | Set as Default
              </span>
            )}
        </div>
      </div>
    ));
  };
  return (
    <>
      <Header />

      <div className="my-address-main-div">
        <div className="account-header">
          <p className="ac-header-para">My Address</p>
        </div>

        <div className="divider" />
        {isLoading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : (
          <div className="address-container">
            <div className="tabular-view-div">
              <div
                className={`address-type-div ${ADDRESS_TYPES.SHIPPING} ${
                  activeAddressType === ADDRESS_TYPES.SHIPPING ? "active" : ""
                }`}
                onClick={() => handleAddressTypeClick(ADDRESS_TYPES.SHIPPING)}
              >
                <p>Shipping Address</p>
              </div>
              <div
                className={`address-type-div ${ADDRESS_TYPES.BILLING} ${
                  activeAddressType === ADDRESS_TYPES.BILLING ? "active" : ""
                }`}
                onClick={() => handleAddressTypeClick(ADDRESS_TYPES.BILLING)}
              >
                <p>Billing Address</p>
              </div>
            </div>
            <div className="lower-address-div">
              {shouldShowAddAddress && (
                <div
                  className="add-address"
                  onClick={() => handleAddress("add")}
                >
                  <div className="add-vector-img">
                    <img src={Icons.plus_vector_icon} alt="Add Address" />
                  </div>
                  <p className="add-address-para">Add Address</p>
                </div>
              )}
              {renderAddressCards()}
            </div>
          </div>
        )}
      </div>

      <RemoveAddressModal
        isOpen={isRemoveModalOpen}
        onClose={cancelRemoveAddress}
        onConfirm={confirmRemoveAddress}
      />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default MyAddress;
